import App from '@/views/constants/app';

import Employees from '@/views/constants/employees';

const Filters = {
  create () {
    return {
      search: '',
      wiaFilter: true,
      vzmFilter: true,
      noneFilter: true,
      pagination: {
        sortBy: 'lastName',
        descending: false,
        rowsPerPage: 25
      }
    };
  }
};

const state = {
  filters: Filters.create()
};

const getters = {
  employeesIndexFilters: state => state.filters
};

const actions = {
  [Employees.Actions.CHANGE_INDEX_FILTER] ({ commit }, data) {
    commit(Employees.Mutations.SET_INDEX_FILTER, data);
  }
};

const mutations = {
  [Employees.Mutations.SET_INDEX_FILTER] (state, payload) {
    state.filters[payload.filter] = payload.value;
  },
  [Employees.Mutations.CLEAR] (state) {
    state.filters = Filters.create();
  },
  [App.Mutations.CLEAR] (state) {
    state.filters = Filters.create();
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
